import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionComponent } from './question.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrMaskerModule } from 'br-mask';

@NgModule({
  declarations: [QuestionComponent],
  imports: [
    CommonModule,
    FormsModule, 
    ReactiveFormsModule,
    BrMaskerModule
  ],
  exports: [
    QuestionComponent
  ]
})
export class QuestionModule { }
